"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = ThreadView;
var _react = _interopRequireWildcard(require("react"));
var _MessageBubble = _interopRequireDefault(require("./MessageBubble"));
var _LoadingIndicator = _interopRequireDefault(require("./LoadingIndicator"));
var _WelcomeScreen = _interopRequireDefault(require("./WelcomeScreen"));
var _Composer = _interopRequireDefault(require("./Composer"));
var _AssistantProvider = require("./AssistantProvider");
var _constants = require("./constants");
var _jsxRuntime = require("react/jsx-runtime");
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
function _interopRequireWildcard(e, t) { if ("function" == typeof WeakMap) var r = new WeakMap(), n = new WeakMap(); return (_interopRequireWildcard = function (e, t) { if (!t && e && e.__esModule) return e; var o, i, f = { __proto__: null, default: e }; if (null === e || "object" != typeof e && "function" != typeof e) return f; if (o = t ? n : r) { if (o.has(e)) return o.get(e); o.set(e, f); } for (const t in e) "default" !== t && {}.hasOwnProperty.call(e, t) && ((i = (o = Object.defineProperty) && Object.getOwnPropertyDescriptor(e, t)) && (i.get || i.set) ? o(f, t, i) : f[t] = e[t]); return f; })(e, t); }
function ScrollToBottom(_ref) {
  let {
    containerRef
  } = _ref;
  const [show, setShow] = _react.default.useState(false);
  (0, _react.useEffect)(() => {
    const el = containerRef.current;
    if (!el) return;
    const onScroll = () => {
      const distFromBottom = el.scrollHeight - el.scrollTop - el.clientHeight;
      setShow(distFromBottom > 120);
    };
    el.addEventListener('scroll', onScroll, {
      passive: true
    });
    return () => el.removeEventListener('scroll', onScroll);
  }, [containerRef]);
  if (!show) return null;
  return (0, _jsxRuntime.jsx)("button", {
    className: "tw-absolute tw-bottom-[90px] tw-left-1/2 tw--translate-x-1/2 tw-w-[34px] tw-h-[34px] tw-rounded-full tw-border tw-border-sa-border tw-bg-sa-surface tw-text-sa-text-sec tw-text-base tw-cursor-pointer tw-shadow-sa tw-flex tw-items-center tw-justify-center tw-z-[5] tw-transition-colors hover:tw-bg-sa-primary-lt hover:tw-text-sa-primary",
    onClick: () => {
      var _containerRef$current;
      (_containerRef$current = containerRef.current) === null || _containerRef$current === void 0 || _containerRef$current.scrollTo({
        top: containerRef.current.scrollHeight,
        behavior: 'smooth'
      });
    },
    "aria-label": "Scroll to bottom",
    children: "\u2193"
  });
}
function ThreadView(_ref2) {
  var _activeThread$message;
  let {
    mode = 'sidebar'
  } = _ref2;
  const {
    activeThread,
    isTyping,
    loadingMessages,
    activeFeature,
    goldenId,
    firstName,
    userName,
    suggestions,
    sendMessage,
    setFeature,
    sidebarWidth,
    setSidebarWidth
  } = (0, _AssistantProvider.useAssistant)();
  const scrollRef = (0, _react.useRef)(null);
  const scrollToEnd = (0, _react.useCallback)(() => {
    const el = scrollRef.current;
    if (el) el.scrollTo({
      top: el.scrollHeight,
      behavior: 'smooth'
    });
  }, []);
  (0, _react.useEffect)(() => {
    scrollToEnd();
  }, [activeThread === null || activeThread === void 0 || (_activeThread$message = activeThread.messages) === null || _activeThread$message === void 0 ? void 0 : _activeThread$message.length, isTyping, scrollToEnd]);
  const messages = (activeThread === null || activeThread === void 0 ? void 0 : activeThread.messages) || [];
  const isEmpty = messages.length === 0 && !isTyping;
  const handleFeatureSelect = featureId => {
    var _meta$samplePrompts;
    const meta = _constants.FEATURE_META[featureId];
    if (meta !== null && meta !== void 0 && (_meta$samplePrompts = meta.samplePrompts) !== null && _meta$samplePrompts !== void 0 && _meta$samplePrompts[0]) {
      if (sidebarWidth < _constants.SIDEBAR.DEFAULT_WIDTH) {
        setSidebarWidth(_constants.SIDEBAR.DEFAULT_WIDTH);
      }
      sendMessage(meta.samplePrompts[0], featureId);
    }
  };
  const isStandalone = mode === 'standalone';
  return (0, _jsxRuntime.jsxs)("div", {
    className: "tw-flex tw-flex-col tw-flex-1 tw-min-h-0 tw-bg-sa-bg tw-relative",
    children: [(0, _jsxRuntime.jsxs)("div", {
      className: "tw-flex-1 tw-overflow-y-auto tw-pt-4 tw-pb-2 tw-flex tw-flex-col tw-gap-3 tw-scroll-smooth",
      ref: scrollRef,
      style: isStandalone ? {
        paddingLeft: '48px',
        paddingRight: '48px'
      } : {
        paddingLeft: '14px',
        paddingRight: '14px'
      },
      children: [isStandalone && (0, _jsxRuntime.jsxs)("div", {
        style: {
          maxWidth: '960px',
          width: '100%',
          margin: '0 auto',
          display: 'flex',
          flexDirection: 'column',
          gap: '20px',
          padding: '8px 0 16px'
        },
        children: [isEmpty && (0, _jsxRuntime.jsx)(_WelcomeScreen.default, {
          goldenId: goldenId,
          firstName: firstName,
          onFeatureSelect: handleFeatureSelect,
          mode: mode
        }), messages.map((msg, i) => (0, _jsxRuntime.jsx)(_MessageBubble.default, {
          message: msg,
          userName: userName,
          isLast: !isTyping && i === messages.length - 1 && msg.role === 'assistant',
          mode: mode
        }, msg.id)), isTyping && (0, _jsxRuntime.jsx)(_LoadingIndicator.default, {
          messages: loadingMessages
        })]
      }), !isStandalone && (0, _jsxRuntime.jsxs)(_jsxRuntime.Fragment, {
        children: [isEmpty && (0, _jsxRuntime.jsx)(_WelcomeScreen.default, {
          goldenId: goldenId,
          firstName: firstName,
          onFeatureSelect: handleFeatureSelect
        }), messages.map((msg, i) => (0, _jsxRuntime.jsx)(_MessageBubble.default, {
          message: msg,
          userName: userName,
          isLast: !isTyping && i === messages.length - 1 && msg.role === 'assistant'
        }, msg.id)), isTyping && (0, _jsxRuntime.jsx)(_LoadingIndicator.default, {
          messages: loadingMessages
        })]
      })]
    }), (0, _jsxRuntime.jsx)(ScrollToBottom, {
      containerRef: scrollRef
    }), (0, _jsxRuntime.jsx)(_Composer.default, {
      onSend: sendMessage,
      isTyping: isTyping,
      activeFeature: activeFeature,
      suggestions: suggestions,
      mode: mode
    })]
  });
}